import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { DEACTIVATE_SUBSCRIPTIONS_API } from "../../services/common/endpoints";
import { callQueryapi } from "../../services/http/callapi";
import ConfirmationModal from "./confirmation-modal";

const SubscriptionsUnsubscribe = ({ item }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [popupShow, setPopupShow] = useState(false);

  const toggleModal = () => {
    setPopupShow(!popupShow);
  };

  const subscriptionDeactivate = useMutation(
    (req) =>
      callQueryapi({
        queryKey: [{}, DEACTIVATE_SUBSCRIPTIONS_API, req],
      }),
    {
      onSuccess: (udata) => {
        const status = udata?.data?.status;
        const infomsg = udata?.data?.infomsg;
        const message = udata?.data?.message;
        try {
          if (status === "0") {
            navigate("/transactionstatus", {
              state: { isoffline: true, isuccess: true, info_message: infomsg, message: message },
            });
          } else {
            navigate("/transactionstatus", {
              state: { isoffline: true, isuccess: false, info_message: infomsg, message: message },
            });
          }
        } catch (e) { }
      },
      onError: () => {
        navigate("/transactionstatus", {
          state: { isoffline: true, isuccess: false, info_message: "", message: "" },
        });
      },
    }
  );
  const callSubscriptionDeactivate = () => {
    let params = {
      msisdn: "",
      id: item?.serviceid,
      planid: item?.planid,
      servicenode: item?.servicenode,
      servicetype: item?.servicetype,
      type: "vas",
    };
    subscriptionDeactivate.mutate(params);
  };

  useEffect(() => {
    if (subscriptionDeactivate?.isSuccess) setPopupShow(false);
    if (subscriptionDeactivate?.isError) {
      setPopupShow(false);
    }
  }, [subscriptionDeactivate?.isSuccess, subscriptionDeactivate?.isError]);

  return (
    <>
      <button
        class="custom_btn custom_btn_sm custom_btn_primary_outline text-initials"
        onClick={() => {
          setPopupShow(true);
        }}
      >
        {t('unsubscribe')}
      </button>

      <ConfirmationModal
        title={''}
        description={item?.popup?.deactivate_message}
        cancelText={item?.popup?.cancel_button?.toUpperCase()}
        show={popupShow}
        submitText={t('unsubscribe_c')}
        toggleModal={() => {
          toggleModal();
        }}
        submit={callSubscriptionDeactivate}
        loading={subscriptionDeactivate.isLoading}
      />
    </>
  );
};

export default SubscriptionsUnsubscribe;
